import React, { useEffect, useMemo, useState } from "react";
import { Heading, Text, Switch } from "../../components";
import axios from "axios";
import { API_DOMAIN } from "config";
import CarCardTemplate from "components/CarCardTemplate";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { he } from "date-fns/locale";
import ContactDetails, { resolveContactDetails } from "components/ContactDetails";
import ContactUserIcon from "components/ContactUserIcon";
registerLocale("he", he);
function ContactPhoneIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.35 1.78.68 2.62a2 2 0 0 1-.45 2.11L8.1 9.64a16 16 0 0 0 6.26 6.26l1.19-1.19a2 2 0 0 1 2.11-.45c.84.33 1.72.56 2.62.68A2 2 0 0 1 22 16.92Z"
        stroke="#7CB342"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const ApprovedContactDetailsInline = ({ data }) => {
  const { contactName, contactPhone, hasContactDetails } = resolveContactDetails(data);

  if (!hasContactDetails) return null;

  return (
    <div
      dir="rtl"
      style={{ backgroundColor: "white" }}
      className="rounded-[18px] border border-gray-200 bg-white shadow-[0_10px_30px_rgba(0,0,0,0.14)] w-[360px] max-w-[92vw] p-5"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div className="text-center font-heebo text-black text-[18px] font-medium">פרטי התקשרות</div>

      <div className="relative mt-4">
        <div className="space-y-2">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-1.5 shrink-0">
              <ContactUserIcon />
              <span className="font-heebo text-black text-[18px] font-medium">שם איש קשר:</span>
            </div>
            <span className="font-heebo text-[16px] text-black text-left break-words">
              {contactName || "-"}
            </span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-1.5 shrink-0">
              <ContactPhoneIcon />
              <span className="font-heebo text-black text-[18px] font-medium">פלאפון:</span>
            </div>
            <span className="font-heebo text-[16px] text-black text-left" dir="ltr">
              {contactPhone || "-"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default function SendNewOfferForm({
  isRejectedOrApproved,
  car,
  currentUser,
  offer,
  onUpdateOffer,
  onClose,
  variant = "popup", // "popup" | "panel"
}) {
  const [updatedOffer, setUpdatedOffer] = useState(null);

  const MAX_PRICE_DIGITS = 7;
  const [step, setStep] = useState(1);

  const [offerForm, setOfferForm] = useState({
    price: offer?.offered_price ?? "",
    offerDate: offer?.creation_date ? new Date(offer.creation_date) : new Date(),
    pickupDate: offer?.collection_date ? new Date(offer.collection_date) : "",
    lastPaymentDate: offer?.last_payment_date ? new Date(offer.last_payment_date) : "",
    reserve: !!offer?.is_reserved,
  });

  const [errors, setErrors] = useState({ price: "" });

  const normalizeOfferLike = (src, fallback = {}) => {
    if (!src) return null;
    const o = src?.offer ? src.offer : src;

    const offered_price = o?.offered_price ?? o?.price ?? o?.offeredPrice ?? fallback?.offered_price;
    const creation_date = o?.creation_date ?? o?.offerDate ?? o?.creationDate ?? fallback?.creation_date;
    const collection_date = o?.collection_date ?? o?.pickup_date ?? o?.pickupDate ?? fallback?.collection_date;
    const last_payment_date = o?.last_payment_date ?? o?.lastPaymentDate ?? fallback?.last_payment_date;
    const is_reserved = o?.is_reserved ?? o?.reserve ?? fallback?.is_reserved;

    return {
      id: o?.id ?? o?.offer_id ?? o?.offerId,
      offer_id: o?.offer_id ?? o?.id ?? o?.offerId,
      offered_price,
      creation_date,
      collection_date,
      last_payment_date,
      is_reserved,
      offer_status: o?.offer_status ?? o?.status ?? fallback?.offer_status,
    };
  };

  const hydrateFromOffer = (srcOffer) => {
    const norm = normalizeOfferLike(srcOffer);
    if (!norm) return false;

    setOfferForm({
      price: norm?.offered_price ?? "",
      offerDate: norm?.creation_date ? new Date(norm.creation_date) : new Date(),
      pickupDate: norm?.collection_date ? new Date(norm.collection_date) : "",
      lastPaymentDate: norm?.last_payment_date ? new Date(norm.last_payment_date) : "",
      reserve: !!Number(norm?.is_reserved),
    });
    return true;
  };
const OfferPriceField = ({ value, onChange, disabled = false, error = "" }) => {
  const pretty = value ? Number(value).toLocaleString("he-IL") : "";

  return (
    <div className="w-full flex flex-col items-center" style={{marginTop: '-19px'}}> 
      <div className="flex items-end justify-center gap-[7px]">
        <span className="!font-heebo text-[18px] font-normal text-black-900_03">
          ₪
        </span>

        {disabled ? (
          // ✅ תצוגה בלי פס מתחת (לא input)
          <span className="text-center text-[24px] font-bold text-red-600 leading-none">
            {pretty}
          </span>
        ) : (
          <input
            type="number"
            name="price"
            value={value}
            onChange={onChange}
            inputMode="numeric"
            className={`
              w-44 border-0 border-b
              ${error ? "border-red-500" : "border-blue_gray-400"}
              bg-transparent
              text-center
              focus:border-black focus:outline-none
            `}
            disabled={disabled}
          />
        )}
      </div>

      {!!error && <div className="mt-1 text-red-600 text-sm text-center">{error}</div>}
    </div>
  );
};
  // ✅ כשה-props של offer מגיעים אסינכרונית/מתעדכנים – למלא מחדש את הטופס
  // (בלי שינוי עיצוב/DOM)
  useEffect(() => {
    const didHydrate = hydrateFromOffer(offer);
    if (!didHydrate) {
      // fallback: יש מקומות שההצעה יושבת בתוך car (כמו בטמפלט השחור)
      hydrateFromOffer(car?.offer ?? car?.user_offer ?? car?.userOffer);
    }

    // אם עוברים בין רכבים/הצעות – לחזור למסך הראשי
    // אבל: אחרי Submit אנחנו עוברים ל-step 2, ו-onUpdateOffer מעדכן את ה-offer ב-Props,
    // מה שמפעיל את ה-effect שוב. לא רוצים להחזיר ל-step 1 במקרה הזה.
    if (step !== 2) {
      setStep(1);
      setUpdatedOffer(null);
    }

    setErrors({ price: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    offer?.offer_id,
    offer?.id,
    offer?.offered_price,
    offer?.creation_date,
    offer?.collection_date,
    offer?.last_payment_date,
    offer?.is_reserved,
    car?.id,
    car?.car_id,
    car?.offer?.offer_id,
    car?.offer?.id,
    car?.user_offer?.offer_id,
    car?.user_offer?.id,
    car?.userOffer?.offer_id,
    car?.userOffer?.id,
  ]);

  const isEdit = !!offer?.id || !!offer?.offer_id || offer?.offer_status == 1;
  const isEditable = offer?.offer_status !== 2 && offer?.offer_status !== 3;

  const handlePriceChange = (e) => {
    let v = String(e.target.value ?? "").replace(/\D/g, "");
    if (v.length > MAX_PRICE_DIGITS) v = v.slice(0, MAX_PRICE_DIGITS);

    setOfferForm((prev) => ({ ...prev, price: v }));
    if (errors.price) setErrors((p) => ({ ...p, price: "" }));
  };

  const validatePrice = () => {
    const min = Number(car?.asking_price || 0);
    const val = Number(offerForm.price);

    if (!offerForm.price) {
      setErrors({ price: "מחיר הוא שדה חובה" });
      return false;
    }
    if (isNaN(val) || val < min) {
      setErrors({ price: "המחיר נמוך ממחיר מינמלי" });
      return false;
    }
    setErrors({ price: "" });
    return true;
  };

  const fmt = (d) => (d ? new Date(d).toISOString().slice(0, 19).replace("T", " ") : null);
const FIELD_ROW_W = "clamp(220px, 16vw, 250px)";
const FIELD_GAP_PX = 8;

// תווית יותר צרה (כדי להיכנס בתוך 250px)
const FIELD_LABEL_W = "clamp(120px, 50%, 140px)";

// הערך מחושב אוטומטית לפי רוחב השורה
const FIELD_VALUE_W = `calc(${FIELD_ROW_W} - ${FIELD_LABEL_W} - ${FIELD_GAP_PX}px)`;
const CustomInput = React.forwardRef(({ value, onClick, label }, ref) => (
  <div
    className="flex items-center justify-center gap-2"
    style={{ width: FIELD_ROW_W }}
  >
    {/* עמודת הערך / תאריך */}
    <input
      ref={ref}
      readOnly
      onClick={onClick}
      value={value ?? ""}
      placeholder="__/__/__"
      className="
        bg-transparent
        text-center
        cursor-pointer
        border-0
        border-b-0
        ring-0
        focus:ring-0
        focus:outline-none
        placeholder:text-gray-400
      "
      style={{ width: FIELD_VALUE_W }}
    />

    {/* עמודת התווית */}
    <span
      className="text-[16px] text-black-900_03 lg:text-[13px] text-right whitespace-nowrap"
      style={{ width: FIELD_LABEL_W }}
    >
      {label}
    </span>
  </div>
));

  const submitOffer = async () => {
    if (!validatePrice()) return;

    const carId = Number(car?.car_id ?? car?.id);
    const currentOfferId = Number(offer?.offer_id ?? offer?.id);

    // בחלק מהזרימות (בעיקר popup במוביל) currentUser יכול להגיע באיחור.
    // ה-backend דורש user_id, לכן עושים fallback למקורות אפשריים נוספים.
    const resolvedUserId =
      Number(currentUser?.id ?? offer?.user_id ?? car?.user_id ?? offer?.userId ?? car?.userId) || null;

    if (!resolvedUserId) {
      console.error("SendNewOfferForm: missing user_id", { currentUser, offer, car });
      alert("שגיאה: לא נמצא משתמש מחובר (user_id חסר). נסי לרענן את העמוד ולהתחבר מחדש.");
      return;
    }

    const payload = {
      car_id: carId,
      user_id: resolvedUserId,
      offered_price: Number(offerForm.price),
      collection_date: fmt(offerForm.pickupDate),
      last_payment_date: fmt(offerForm.lastPaymentDate),
      is_reserved: offerForm.reserve ? 1 : 0,
      creation_date: offerForm.offerDate.toISOString().slice(0, 19).replace("T", " "),
    };

    try {
      if (currentOfferId) {
        await axios.post(`${API_DOMAIN}/offer/updateOffer/${currentOfferId}`, payload);
      } else {
        await axios.post(`${API_DOMAIN}/offer/addOffer`, payload);
      }

      const resp = await axios.get(`${API_DOMAIN}/offer/getUserOffer`, {
        params: { car_id: carId, user_id: resolvedUserId },
      });

      const raw = resp?.data;
      const fresh = Array.isArray(raw) ? raw[0] : raw?.offer ? raw.offer : raw;

      const upd = {
        ...(fresh || {}),
        offer_id: Number(fresh?.offer_id ?? fresh?.id ?? currentOfferId),
        car_id: carId,
        offered_price: Number(fresh?.offered_price ?? offerForm.price),
        collection_date: fresh?.collection_date ?? fmt(offerForm.pickupDate),
        last_payment_date: fresh?.last_payment_date ?? fmt(offerForm.lastPaymentDate),
        is_reserved: Number(fresh?.is_reserved ?? (offerForm.reserve ? 1 : 0)),
        offer_status: Number(fresh?.offer_status ?? offer?.offer_status ?? 1),
      };

      setUpdatedOffer(upd);
      onUpdateOffer?.(upd);
      setStep(2);
    } catch (err) {
      console.error(err);
      alert("אירעה שגיאה בשמירת ההצעה");
    }
  };
const [canHoverDevice, setCanHoverDevice] = useState(false);
const popupWrapperStyle = useMemo(() => {
  const isPopup = variant === "popup";

  return {
    maxHeight: isPopup ? (canHoverDevice ? "none" : "calc(100vh - 110px)") : "none",
    overflowY: isPopup ? (canHoverDevice ? "visible" : "auto") : "visible",
    overflowX: "hidden",
    WebkitOverflowScrolling: "auto", // ✅ לא touch
    paddingInline: "8px",
    paddingBottom: "20px",
    boxSizing: "border-box",
  };
}, [variant, canHoverDevice]);
useEffect(() => {
  if (typeof window === "undefined" || !window.matchMedia) return;

  const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
  const update = () => setCanHoverDevice(mq.matches);
  update();

  if (mq.addEventListener) {
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  } else {
    mq.addListener(update);
    return () => mq.removeListener(update);
  }
}, []);
  const myOfferRankText = useMemo(() => {
    const posRaw =
      updatedOffer?.offer_position ??
      offer?.offer_position ??
      offer?.offerPosition ??
      car?.offer?.offer_position ??
      car?.user_offer?.offer_position ??
      car?.userOffer?.offer_position;

    const pos = Number(posRaw);
    if (!Number.isFinite(pos) || pos <= 0) return "";

    // Server returns numeric position (1 = best)
    return String(pos);
  }, [updatedOffer?.offer_position, offer?.offer_position, offer?.offerPosition, car]);
const effectiveOfferStatus = Number(updatedOffer?.offer_status ?? offer?.offer_status ?? 0);
const isApproved = effectiveOfferStatus === 2;

const contactData = useMemo(() => {
  const src = { ...(car || {}), ...(offer || {}), ...(updatedOffer || {}) };

  return {
    ...src,

    // התאמות שמות (למקרה שבמקום אחד זה supplier_* ובמקום אחר provider_*)
    supplier_name:
      src.supplier_name ?? src.provider_name ?? src.business_name ?? src.name ?? null,

    contact_name:
      src.contact_name ?? src.provider_contact_name ?? src.contactName ?? null,

    contact_phone:
      src.contact_phone ?? src.provider_phone_number ?? src.phone_number ?? src.contactPhone ?? null,

    contact_location:
      src.contact_location ?? src.full_address ?? src.contactLocation ?? null,
  };
}, [car, offer, updatedOffer]);
  // ✅ שמירה על אותו DOM/מחלקות כמו SendNewOfferPopup (עיצוב לא ישתנה)
  return (
    <>
      {variant === "popup" && (
        <button className="x-close" onClick={onClose}>
          ✕
        </button>
      )}

{step == 1 && (
<div
 className="w-full" style={popupWrapperStyle}  
>
  
<h2 className="add-car-title mt-3 left-side snop-title text-center" style={{ color: "black", marginBottom: "1.5rem" }}>            {(offer?.offer_status !== 2 && offer?.offer_status !== 3) && (
              <>{isEdit ? "עדכן את ההצעה שלך" : "הגש הצעה חדשה"}</>
            )}
          </h2>
<div
  className="flex mt-3 justify-center w-full min-w-0"
  style={{
    width: "100%",
    maxWidth: variant === "panel" ? "100%" : FIELD_ROW_W,
    marginInline: "auto",
    position: "relative",
  }}
>
  <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
    <CarCardTemplate
      key={car?.id}
      offer_status={offer?.offer_status ?? 0}
      isRejectedOrApproved={isRejectedOrApproved}
      {...car}
      className="w-full self-center"
      offered_price={offerForm.price}
    />
  </div>
</div>
<div className={`w-full flex justify-center min-w-0 ${canHoverDevice ? "overflow-visible" : "overflow-x-hidden"}`}>  <div
    className="snop-form mt-3.5 w-full"
style={{
  width: FIELD_ROW_W,          // רוחב קבוע לשמירת היישור
  minWidth: FIELD_ROW_W,       // שלא יתכווץ וישבור עמודות
  maxWidth: FIELD_ROW_W,
  margin: "14px auto 0",
  float: "none",
  position: "static",
  left: "auto",
  right: "auto",
  paddingInline: 0,
  flexShrink: 0,               // חשוב בתוך overflow-x-auto
}}
  >
    <div style={{marginTop:'-19px'}} className="w-full flex flex-col items-center gap-5">
<div className="flex justify-center w-full">
  <div
    className="flex items-center justify-center gap-2 mt-5"
    style={{ width: FIELD_ROW_W }}
  >
    {/* עמודת הערך */}
    <div className="flex justify-center" style={{ width: FIELD_VALUE_W }}>
      <span className="text-red-600 font-semibold text-[18px]">
        ₪{Number(car?.asking_price ?? 0).toLocaleString()}
      </span>
    </div>

    {/* עמודת התווית */}
    <div className="text-right" style={{ width: FIELD_LABEL_W }}>
      <span className="text-[16px] text-black-900_03 lg:text-[13px]">מחיר מינימום</span>
    </div>
  </div>
</div>
<div className="flex justify-center w-full">
  <div
    className="flex items-center justify-center gap-2"
    style={{ width: FIELD_ROW_W }}
  >
    {/* עמודת ערך ריקה כדי לשמור על אותו יישור */}
    <div style={{ width: FIELD_VALUE_W }} />

    {/* עמודת התווית */}
    <div className="text-right" style={{ width: FIELD_LABEL_W }}>
      <span className="text-[16px] text-black-900_03 lg:text-[13px] font-medium">
        תן הצעת מחיר
      </span>
    </div>
  </div>
</div>
                {/* === מחיר + הודעת שגיאה === */}
 <div className="flex flex-col items-center">
  <div className="flex items-end justify-center gap-[7px]">
    <span className="!font-heebo text-[18px] font-normal text-black-900_03 leading-none">
      ₪
    </span>

    <input
      type="number"
      name="price"
      value={offerForm.price}
      onChange={handlePriceChange}
      inputMode="numeric"
      className={`
        w-44 border-0 border-b
        ${errors.price ? "border-red-500" : "border-blue_gray-400"}
        bg-transparent
        text-center
        text-[24px] font-bold text-red-600 leading-none
        focus:border-black focus:outline-none
      `}
      disabled={!isEditable}
    />
  </div>

  {!!errors.price && (
    <div className="mt-1 text-red-600 text-sm text-center">{errors.price}</div>
  )}
</div>
                {/* תאריך הצעה + תאריך איסוף */}
                <div className="flex flex-col gap- md:flex-column items-center justify-center">
                  <DatePicker
                    style={{ zIndex: "9999" }}
                    popperClassName="my-datepicker-popper"
                    locale="he"
                    selected={offerForm.offerDate}
                    dateFormat="dd/MM/yyyy"
                    calendarStartDay={0}
                    disabled
                    customInput={<CustomInput label=":תאריך ההצעה" />}
                    popperContainer={({ children }) => <div style={{ zIndex: 99999 }}>{children}</div>}
                    popperPlacement="bottom-start"
                  />

                  <DatePicker
                    locale="he"
                    style={{ zIndex: "99" }}
                    withPortal
                    popperClassName="my-datepicker-popper"
                    selected={offerForm.pickupDate}
                    onChange={(d) => setOfferForm((p) => ({ ...p, pickupDate: d }))}
                    dateFormat="dd/MM/yyyy"
                    calendarStartDay={0}
                    customInput={<CustomInput label=":תאריך איסוף" />}
                    popperContainer={({ children }) => <div style={{ zIndex: 99999 }}>{children}</div>}
                    popperPlacement="bottom-start"
                    disabled={!isEditable}
                    minDate={new Date()}
                  />

                  <DatePicker
                    locale="he"
                    withPortal
                    selected={offerForm.lastPaymentDate}
                    popperClassName="my-datepicker-popper"
                    onChange={(d) => setOfferForm((p) => ({ ...p, lastPaymentDate: d }))}
                    dateFormat="dd/MM/yyyy"
                    calendarStartDay={0}
                    customInput={<CustomInput label=":תאריך סיום תשלום" />}
                    popperContainer={({ children }) => <div style={{ zIndex: 1000 }}>{children}</div>}
                    popperPlacement="bottom-start"
                    disabled={!isEditable}
                    minDate={new Date()}
                  />
                </div>

           <div className="w-full flex justify-center">
  <div
    className="flex items-center justify-center gap-2"
    style={{ width: FIELD_ROW_W }}
  >
    {/* עמודת הערך */}
    <div
      className="flex justify-center"
      style={{ width: FIELD_VALUE_W }}
    >
      <Switch
        checked={!offerForm.reserve}
        onCheckedChange={(val) => {
          if (!isEditable) return;
          setOfferForm((prev) => ({ ...prev, reserve: !val }));
        }}
      />
    </div>

    {/* עמודת התווית */}
    <Text
      size="textxl"
      as="p"
      className="text-[16px] font-normal !text-black-900_03 lg:text-[13px] text-right"
      style={{ width: FIELD_LABEL_W }}
    >
      שיריון הרכב
    </Text>
    {/* פרטי התקשרות - רק בהצעה מאושרת (אותו עיצוב כמו OfferCard) */}

  </div>

</div>
{isApproved && (
  <div className="w-full flex justify-center relative mt-3" dir="rtl">
    {canHoverDevice ? (
      // ✅ דסקטופ: כרטיס קבוע (בלי tooltip)
      <ApprovedContactDetailsInline data={{ ...contactData }} />
    ) : (
      // ✅ מובייל/טאץ׳: נשאר בדיוק כמו ContactDetails שלך
      <ContactDetails
        data={{ ...contactData }}
        buttonClassName="min-w-[140px] rounded-[14px] px-[16px] py-[10px] font-assistant font-medium border border-gray-200 bg-white shadow-sm flex items-center justify-center gap-2"
        tooltipWrapperClassName="absolute bottom-[calc(100%+10px)] left-1/2 -translate-x-1/2 z-[2000]"
        showArrow
      />
    )}
  </div>
)}

                {offer?.offer_status != 2 && offer?.offer_status != 3 && (
                  <div style={{ display: "flex", justifyContent: "end", marginTop: "1rem" }}>
                    <button
                      size="lg"
                      shape="round"
                      leftIcon={
                        <div className="flex h-[10px] w-[6px] items-center justify-center">
                          <span className="text-lg leading-none">‹</span>
                        </div>
                      }
                      className="z-10 min-w-[185px] gap-2 py-2 rounded-[50px] px-3 font-semibold text-white snop-submitBtn "
                      style={{ background: "black", color: "white", width: "auto", whiteSpace: "nowrap" }}
                      onClick={submitOffer}
                    >
                      <span className="flex items-center justify-center gap-2 whitespace-nowrap">
                        {isEdit ? "עדכן הצעת מחיר" : "שלח הצעת מחיר"}
                        <img src="/images/offer-white.svg" alt="offer" className="h-4 w-4" />
                      </span>
                    </button>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      )}

      {step == 2 && (
        <div
 className="w-full" style={popupWrapperStyle}        
        >
          {/* הודעת הצלחה (מעל הכרטיס) */}
          <div className="w-full flex justify-center mt-2 mb-2">
            <h2 className="add-car-title mt-3 left-side snop-title text-center" style={{ color: "black", marginBottom: "1.5rem" }}>
              {(offer?.offer_status !== 2 && offer?.offer_status !== 3) && (
                <span>
                  {isEdit ? "ההצעה שלך עודכנה בהצלחה" : "ההצעה שלך נשלחה בהצלחה"}
                </span>
              )}
            </h2>
          </div>

          <div className="flex justify-center w-full">
            <CarCardTemplate
              key={car?.id}
              {...car}
              offer_status={updatedOffer?.offer_status ?? 1}
              offered_price={offerForm.price}
              className="w-full max-w-[300px] sm:w-[100%] self-center"
            />
          </div>

          {/* שדות כמו שלב 1 (ללא אפשרות עריכה) */}
          <div className={`w-full flex justify-center min-w-0 ${canHoverDevice ? "overflow-visible" : "overflow-x-hidden"}`}>
            <div
              className="snop-form mt-3.5 w-full"
              style={{
                width: FIELD_ROW_W,
                minWidth: FIELD_ROW_W,
                maxWidth: FIELD_ROW_W,
                margin: "14px auto 0",
                float: "none",
                position: "static",
                left: "auto",
                right: "auto",
                paddingInline: 0,
                flexShrink: 0,
              }}
            >


              {/* סטטוס (מעל ההצגה של המחיר) */}
<div className="w-full flex justify-center">
  <h2
    className="add-car-title mt-3 left-side snop-title text-center"
    style={{ color: "black", marginBottom: "0.75rem" }}
  >
    {isEdit ? "ההצעה שלך עודכנה בהצלחה" : "ההצעה שלך נשלחה בהצלחה"}
  </h2>
</div>
              <div className="w-full flex flex-col items-center gap-5">
                {/* מחיר מינימום */}
                <div className="flex justify-center w-full">
                  <div className="flex items-center justify-center gap-2" style={{ width: FIELD_ROW_W }}>

                    <div className="text-center" style={{ width: FIELD_LABEL_W }}>
                      <span className="text-[16px] text-black-900_03 lg:text-[13px]">הצעת מחיר שלי</span>
                    </div>
                  </div>
                </div>

                {/* מחיר */}
     <OfferPriceField
  value={offerForm.price}
  onChange={handlePriceChange}
  disabled={true}
  error={errors.price}
/>
   <div className="text-center" style={{ width: FIELD_LABEL_W }}>
  <div className="flex flex-row-reverse items-center justify-center gap-2">
    <span className="text-[16px] text-black-900_03 lg:text-[13px]">
      מיקומך: {myOfferRankText}
    </span>

    <img
      src="/images/yourPlace.svg"
      alt="offer"
    />
  </div>
</div>


                {/* תאריכים */}
                <div className="flex flex-col gap- md:flex-column items-center justify-center">
                  <DatePicker
                    style={{ zIndex: "9999" }}
                    popperClassName="my-datepicker-popper"
                    locale="he"
                    selected={offerForm.offerDate}
                    dateFormat="dd/MM/yyyy"
                    calendarStartDay={0}
                    disabled
                    customInput={<CustomInput label=":תאריך ההצעה" />}
                    popperContainer={({ children }) => <div style={{ zIndex: 99999 }}>{children}</div>}
                    popperPlacement="bottom-start"
                  />

                  <DatePicker
                    locale="he"
                    style={{ zIndex: "99" }}
                    withPortal
                    popperClassName="my-datepicker-popper"
                    selected={offerForm.pickupDate}
                    onChange={() => {}}
                    dateFormat="dd/MM/yyyy"
                    calendarStartDay={0}
                    disabled
                    customInput={<CustomInput label=":תאריך איסוף" />}
                    popperContainer={({ children }) => <div style={{ zIndex: 99999 }}>{children}</div>}
                    popperPlacement="bottom-start"
                    minDate={new Date()}
                  />

                  <DatePicker
                    locale="he"
                    withPortal
                    selected={offerForm.lastPaymentDate}
                    popperClassName="my-datepicker-popper"
                    onChange={() => {}}
                    dateFormat="dd/MM/yyyy"
                    calendarStartDay={0}
                    disabled
                    customInput={<CustomInput label=":תאריך סיום תשלום" />}
                    popperContainer={({ children }) => <div style={{ zIndex: 1000 }}>{children}</div>}
                    popperPlacement="bottom-start"
                    minDate={new Date()}
                  />
                </div>

                {/* שיריון הרכב */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center justify-center gap-2" style={{ width: FIELD_ROW_W }}>
                    <div className="flex justify-center" style={{ width: FIELD_VALUE_W }}>
                      <Switch checked={!offerForm.reserve} onCheckedChange={() => {}} disabled />
                    </div>
                    <Text
                      size="textxl"
                      as="p"
                      className="text-[16px] font-normal !text-black-900_03 lg:text-[13px] text-right"
                      style={{ width: FIELD_LABEL_W }}
                    >
                      שיריון הרכב
                    </Text>
                  </div>
                </div>
                  {/* פרטי התקשרות - רק בהצעה מאושרת (אותו עיצוב כמו OfferCard) */}
{isApproved && (
  <div className="w-full flex justify-center relative mt-3" dir="rtl">
    {canHoverDevice ? (
      // ✅ דסקטופ: כרטיס קבוע (בלי tooltip)
      <ApprovedContactDetailsInline data={{ ...contactData }} />
    ) : (
      // ✅ מובייל/טאץ׳: נשאר בדיוק כמו ContactDetails שלך
      <ContactDetails
        data={{ ...contactData }}
        buttonClassName="min-w-[140px] rounded-[14px] px-[16px] py-[10px] font-assistant font-medium border border-gray-200 bg-white shadow-sm flex items-center justify-center gap-2"
        tooltipWrapperClassName="absolute bottom-[calc(100%+10px)] left-1/2 -translate-x-1/2 z-[2000]"
        showArrow
      />
    )}
  </div>
)}
                {/* כפתור שנה הצעה */}
                
                                    <div style={{ display: "flex", justifyContent: "end", marginTop: "1rem" }}>
                    <button
                      size="lg"
                      shape="round"
                      leftIcon={
                        <div className="flex h-[10px] w-[6px] items-center justify-center">
                          <span className="text-lg leading-none">‹</span>
                        </div>
                      }
                      className="z-10 min-w-[185px] gap-2 py-2 rounded-[50px] px-3 font-semibold text-white snop-submitBtn "
                      style={{ background: "black", color: "white", width: "auto", whiteSpace: "nowrap" }}
                    onClick={() => setStep(1)}
                    >
                      <span className="flex items-center justify-center gap-2 whitespace-nowrap">
                    שנה הצעה
                        <img src="/images/offer-white.svg" alt="offer" className="h-4 w-4" />
                      </span>
                    </button>
                  </div>
             
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}